import { createFileRoute } from '@tanstack/react-router'
import ContactCompanyContacts from 'Contact/components/Contact/Sections/ContactCompanyContacts'

export const Route = createFileRoute('/contact/$contactId/companycontacts')({
    component: ContactCompanyContacts,
})
